import { getAPI } from "./base";

// Suppliers
export async function fetchSuppliersToShow(formValues) {
  try {
    const api = getAPI();
    const params = {
      country: formValues.country,
      category: formValues.category,
      L2: formValues.L2,
      L3: formValues.L3,
      L4: formValues.L4,
      equip_serv: formValues.equipment,
      region: formValues.region,
      requirements: formValues.requirements,
      context: formValues.context || null,
    };

    const response = await api.get("/suppliersforshow", { params });
    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error fetching data: ", response.statusText);
      return [];
    }
  } catch (error) {
    console.error("Error fetching data: ", error);
    throw error;
  }
}

// Existing Suppliers
export async function fetchExistingSuppliers(formValues) {
  try {
    const api = getAPI();
    const params = {
      L2: formValues.L2,
      L3: formValues.L3,
      l4: formValues.L4,
    };

    const response = await api.get("/suppliersnew", { params });
    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error fetching data: ", response.statusText);
      return [];
    }
  } catch (error) {
    console.error("Error fetching data: ", error);
    throw error;
  }
}